var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeliveryTruck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.5 17.2l-4.9-8.9c-.2-.3-.5-.5-.8-.5h-5.6c-.5 0-.9.4-.9.9v15.2H5c-.5 0-.9.4-.9.9v6.7c0 .5.4.9.9.9h1.5c.4 2 2.2 3.5 4.4 3.5 2.1 0 3.9-1.5 4.4-3.5h10c.4 2 2.2 3.5 4.4 3.5s3.9-1.5 4.4-3.5H36c.5 0 .9-.4.9-.9V17.6c-.3-.1-.3-.2-.4-.4zm-1.7 13.5h-1c-.4-2-2.2-3.5-4.4-3.5s-3.9 1.5-4.4 3.5H15c-.4-2-2.2-3.5-4.4-3.5-2.1 0-3.9 1.5-4.4 3.5h-.3v-4.9h29v4.9zm-5.4 3.5c-1.5 0-2.6-1.2-2.6-2.6 0-1.5 1.2-2.6 2.6-2.6 1.5 0 2.6 1.2 2.6 2.6.1 1.4-1.1 2.6-2.6 2.6zm-18.6 0c-1.5 0-2.6-1.2-2.6-2.6 0-1.5 1.2-2.6 2.6-2.6 1.5 0 2.6 1.2 2.6 2.6 0 1.4-1.2 2.6-2.6 2.6zm24-10.3H26V9.6h4.2l4.5 8.2.1 6.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.9 22.8h17c.5 0 .9-.4.9-.9v-17c0-.5-.4-.9-.9-.9h-17c-.5 0-.9.4-.9.9v17c0 .5.4.9.9.9zM19.8 21H7.1l6.3-6.3 6.4 6.3zM7.1 5.7h12.7L13.5 12 7.1 5.7zm7.6 7.7L21 7v12.7l-6.3-6.3zM5.8 7l6.3 6.3-6.3 6.3V7zM28.5 17.7c-.5 0-.9.4-.9.9s.4.9.9.9h1.4c.5 0 .9-.4.9-.9s-.4-.9-.9-.9h-1.4z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryTruck);
export default __webpack_public_path__ + "static/media/delivery-truck.6a4307ff.svg";
export { ForwardRef as ReactComponent };